const isTouchDevice =
  "ontouchstart" in window
  || (navigator as any).MaxTouchPoints > 0
  || navigator.msMaxTouchPoints > 0;

export default isTouchDevice;